import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { CAREGIVER_PENDING_APPROVAL_ERROR_MESSAGE } from 'features/auth/constants';
import { Error } from 'store/api';
import { isFetchBaseQueryError } from 'utils';

const ERROR_UNDERAGE = 'user is under minimum age limit';

export const isEmailAlreadyRegisteredError = (
  error: FetchBaseQueryError | SerializedError,
): boolean =>
  isFetchBaseQueryError(error) &&
  error.status === 422 &&
  typeof error.data === 'object' &&
  error.data !== null &&
  'errors' in error.data &&
  typeof error.data.errors === 'object' &&
  error.data.errors !== null &&
  'email' in error.data.errors;

export const isUnderageError = (error: Error | SerializedError): boolean =>
  (isFetchBaseQueryError(error) &&
    error.status === 422 &&
    error.data.errors?.eligibility?.includes(ERROR_UNDERAGE)) ??
  false;

export const isUserCreationFailedError = (error: FetchBaseQueryError | SerializedError): boolean =>
  isFetchBaseQueryError(error) &&
  error.status === 422 &&
  typeof error.data === 'object' &&
  error.data !== null &&
  'errors' in error.data &&
  typeof error.data.errors === 'object' &&
  error.data.errors !== null &&
  !('email' in error.data.errors);

export const isCaregiverPendingApprovalError = (error: Error | SerializedError): boolean =>
  (isFetchBaseQueryError(error) &&
    error.status === 403 &&
    error.data.errors?.access?.includes(CAREGIVER_PENDING_APPROVAL_ERROR_MESSAGE)) ??
  false;
